import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

export function listClientVendors(clientViewId, params = {}) {
  return clientPortalRequest(
    `/views/${clientViewId}/vendors${buildClientQuery(params)}`
  );
}

export function getClientVendor(clientViewId, vendorId) {
  return clientPortalRequest(`/views/${clientViewId}/vendors/${vendorId}`);
}

export function createClientVendor(clientViewId, payload) {
  return clientPortalRequest(`/views/${clientViewId}/vendors`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateClientVendor(clientViewId, vendorId, payload) {
  return clientPortalRequest(`/views/${clientViewId}/vendors/${vendorId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}
